import { useEffect, useState } from 'react';
import { Plane, Activity } from 'lucide-react';
import { META, ROUTES } from './data';

// Stratos Header — DASHBOARD style. Top status bar + main nav row.
// Distinctive: live UTC clock + cert pills, NO marquee, NO transparent-on-scroll.
export default function Header({ page, setPage }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const utc = now.toUTCString().split(' ')[4];

  return (
    <header className="sticky top-0 z-40 bg-[#0F0F11] border-b border-[#EAF1F4]/10">
      {/* Status bar */}
      <div className="bg-[#06060A] border-b border-[#EAF1F4]/8">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 h-7 flex items-center justify-between font-mono text-[10px] tracking-[0.18em] uppercase text-[#EAF1F4]/55">
          <div className="flex items-center gap-5">
            <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-[#5FFB7A] animate-pulse" /> OPS · ACTIVE</span>
            <span className="hidden md:inline">{META.cert}</span>
          </div>
          <div className="flex items-center gap-5">
            <span className="hidden sm:inline">UTC {utc}</span>
            <span className="text-[#D73B26]">+44 20 7993 0140</span>
          </div>
        </div>
      </div>
      {/* Main row */}
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-center gap-3 text-[#EAF1F4]" data-testid="jet-logo">
          <Plane className="w-5 h-5 text-[#D73B26]" strokeWidth={1.4} />
          <span>
            <span className="font-serif text-xl tracking-tight">{META.brand}</span>
            <span className="font-mono text-[8px] tracking-[0.4em] uppercase text-[#EAF1F4]/45 block leading-tight">{META.tagline}</span>
          </span>
        </button>
        <nav className="hidden lg:flex items-center gap-1 bg-[#06060A] border border-[#EAF1F4]/10 rounded-sm p-1">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`jet-nav-${r.id}`}
              className={`px-4 py-1.5 font-mono text-[10px] tracking-[0.22em] uppercase transition-colors ${page === r.id ? 'bg-[#D73B26] text-[#0F0F11]' : 'text-[#EAF1F4]/60 hover:text-[#EAF1F4]'}`}>
              {r.label}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('quote')} className="flex items-center gap-2 bg-[#D73B26] text-[#0F0F11] px-4 py-2 font-mono text-[10px] tracking-[0.22em] uppercase hover:bg-[#EAF1F4] transition-colors" data-testid="jet-cta-quote">
          <Activity className="w-3 h-3" strokeWidth={2} /> Live Quote
        </button>
      </div>
    </header>
  );
}
